import chunk from 'lodash-es/chunk'
import cloneDeep from 'lodash-es/cloneDeep'
import noop from 'lodash-es/noop'
import orderBy from 'lodash-es/orderBy'
import uniq from 'lodash-es/uniq'
import { addCollectionsToFeature, deleteFeature, deleteFeatures, getFeatureById, getImportedData, getUserData, removeCollectionsFromFeature, saveFeature, updateBulkFeatureStyles, updateFeature } from '../services/udapi/features'
import { addFeaturesToCollections, addFeatureToCollections } from '../services/udapi/collections'
import { deletePhoto, getNewPhotoId, getPhoto } from '../services/udapi/photos'
import { exportFeatures, getExportDetails } from '../services/udapi/exports'
import { FEATURE_FILTERS, FEATURE_TYPES, LARGE_DATA_SET_COUNT, MAP_LAYER_IDS, STATES_DATA } from '../lib/constants'
import { getShareToken } from '../services/udapi/sharing'
import { getShortShareLink } from '../services/firebase'
import { saveFavoriteIcons, saveRecentStyles, saveVisibleFeatures } from '../lib/userPreferences'
import { /* setVisibleFeaturesOnLoad, */ setVisibleFeaturePayloads } from '../lib/features'
import { isEqual } from '../lib/utils'

/*
  #TODO: Investigate Redux libraries that can listen for changes in the model
  and dispatch calls to the backend to persist those changes. That could really
  clear up a lot of logic around here.
  -- TJC - March 22, 2020
*/

/*
  #TODO: Clean up and organize these model files.
  -- TJC - August 03, 2021
*/
/* #TODO
	* Deprecated
		* Hiddenfeatures: 
			* Remove after all user preference records have been migrated
		* RecenltyAdded:  
			* Remove after mobile has implemented user preferences and is in sync with web
		* Temporary solution - 11-02-22 JT
*/

export default {
	namespace: 'features',

	state: {
		featureErrorId: '',
		featuresList: [],
		featuresLoading: true,
		filters: {
			/*
        #TODO: Refactor to just be a list of names. Seeing whether or not a state is
        being filtered on is simply checking to see if it's in the filter list. We have
        a list of all states in the Constants file.
        -- TJC - May 04, 2020
      */
			/*
        #TODO: We can use a Set() for the states list for ease of addition and removal of
        values in O(1) time.
        -- TJC - May 15, 2020
      */
			states: [], // STATES_DATA.map(name => ({name, checked: true})),
			types: [...Object.keys(FEATURE_FILTERS)],
		},
		hasFeatureErrored: false,
		hasLargeFeatureDataSet: false,
		isCanceling: false,
		isCreatingItems: false,
		isDeletingItems: false,
		isDeselectingItems: false,
		isEditingFeature: false,
		isFeatureDirty: false,
		isHidingItems: false,
		isSaving: false,
		isSelectingItems: false,
		isSettingVisibility: false,
		isShowingItems: false,
		isSortingItems: false,
		isUploadingPhoto: false,
		mapSelectList: [],
		moreFeaturesLoading: true,
		newFeature: null,
		newVisibleFeatures: [],
		pagination: {
			limit: 500,
			offset: 0,
			total: 0,
		},
		preferences: {
			deprecated: {
				hiddenFeatures: [],
			},
			favorites: {
				icons: [],
			},
			recents: {
				styles: {
					points: [],
				},
			},
			visible: {
				all: true,
				collections: [],
				features: [],
			},
		},
		previousFeaturesState: [],
		previousFeatureState: null,
		selectedFeature: null,
		selectedFeatureLoading: false,
		selectedFeatures: [],
		selectedFeaturesCount: 0,
		sort: 'updatedAt',
	},

	effects: {
		getUserDataPoll: [
			function* ({ callback }, { call, put, select }) {
				const { filters, pagination, preferences: { deprecated, visible }, sort } = yield select((model) => model.features)

				const queryParams = {
					ascending: sort == 'title' ? true : false,
					limit: pagination.limit,
					offset: pagination.offset,
					slim: true,
					sort: sort,
					states: filters.states.map((item) => (item.checked ? item.name : false)).filter(Boolean),
					types: filters.types,
				}

				const response = yield call(getUserData, { queryParams })
				if (response.success) {
					const featuresList = response.data
					const existingVisibleFeaturesSet = new Set(visible.features)
					const newVisibleFeatures = []
					const hasHiddenFeatures = deprecated.hiddenFeatures?.length > 0
					const hiddenFeaturesSet = new Set(deprecated.hiddenFeatures)
				
					if (!visible.all || hasHiddenFeatures) {
						let feature = null
						for (let li = 0; li < featuresList.length; li++) {
							feature = featuresList[li]
							feature.isVisible = existingVisibleFeaturesSet.has(featuresList[li].id)
							if (hasHiddenFeatures && !hiddenFeaturesSet.has(feature.uuid)) {
								feature.isVisible = true
							}
						
							if (!feature.isVisible && !hasHiddenFeatures) {
								const { createdAt, serverCreatedAt, updatedAt } = feature.properties
								if (feature.isOwner) {
									feature.isVisible = serverCreatedAt >= visible.updatedAt || createdAt >= visible.updatedAt
								} else {
									feature.isVisible = updatedAt >= visible.updatedAt
								}
							}
						
							if (feature.isVisible && !existingVisibleFeaturesSet.has(feature.id)) {
								newVisibleFeatures.push(feature.id)
							}
						}
					} else {
						for (let li = 0; li < featuresList.length; li++) {
							featuresList[li].isVisible = true
						}
					}
					yield put({
						type: 'map/renderMultipleFeatureGraphics',
						payload: {
							featuresList,
							layerId: MAP_LAYER_IDS.content,
						},
					})
					
					yield put({ type: 'appendFeatures', payload: featuresList })
					yield put({
						type: 'setFeatureTotalCount',
						payload: response.data.length + pagination.total,
					})
					yield put({ type: 'setNewVisibleFeatures', payload: newVisibleFeatures })
					if (response.data.length === pagination.limit) {
						yield put({
							type: 'setOffset',
							payload: response.data.length + pagination.offset,
						})
					} else {
						const { newVisibleFeatures } = yield select((model) => model.features)
						if (newVisibleFeatures.length > 0) {
							yield put({ type: 'setVisibleFeaturesEffect', payload: [{ features: newVisibleFeatures, type: 'feature', visibility: true }] })
						}
						yield put({ type: 'setFeaturesLoading', payload: false })
						yield put({ type: 'setMoreFeaturesLoading', payload: false })
						callback()
					}
				} else {
					yield put({ type: 'setFeaturesLoading', payload: false })
					yield put({ type: 'setMoreFeaturesLoading', payload: false })
					callback()
				}
			},
			{ type: 'poll', delay: 250 },
		],
		getExportPoll: [
			function* ({ callback, payload: exportId }, { call }) {
				let response = yield call(getExportDetails, exportId)

				if (response.success) {
					if (response.data.success != null) {
						yield call(callback, response.data.url)
					}
				} else {
					console.error('ERROR: unable to retrieve exported data', response)
					yield call(callback, null)
				}
			},
			{ type: 'poll', delay: 750 },
		],
		getPhotoPoll: [
			function* ({ callback, payload }, { call }) {
				const response = yield call(getPhoto, payload)
				if (response.success) {
					if (response.data.pathThumbnail) {
						yield call(callback, response)
					}
				} else {
					console.error('ERROR: Unable to retrieve photo', response)
					yield call(callback, null)
				}
			},
			{ type: 'poll', delay: 750 },
		],
		*getImportedData({ callback = noop }, { call, put, select }) {
			const { importedFeatures } = yield select((model) => model.dataManager)
			let featureIds = importedFeatures.map((f) => f.uuid)
			let failedFeatures = []
			let successfulFeatures = []
			let response = null

			const featureIdsChunk = chunk(featureIds, 1000)
			for (let featureIdChunk of featureIdsChunk) {
				response = yield call(getImportedData, featureIdChunk)
				if (response.success) {
					if (response.data.successful) {
						successfulFeatures = [...successfulFeatures, ...response.data.successful]
					} else if (response.data.failed) {
						failedFeatures = [...failedFeatures, ...response.data.failed]
					}
				} else {
					failedFeatures = [...featureIds]
				}
			}

			if (successfulFeatures.length) {
				const features = []
				for (let sfi = 0; sfi < successfulFeatures.length; sfi++) {
					successfulFeatures[sfi].isVisible = true
					features.push(successfulFeatures[sfi].id)
				}
				yield put({
					type: 'map/renderMultipleFeatureGraphics',
					payload: {
						featuresList: successfulFeatures,
						layerId: MAP_LAYER_IDS.content,
					},
				})
				yield put({ type: 'setVisibleFeaturesEffect', payload: [{ type: 'feature', visibility: true, features }] })
				yield put({ type: 'appendFeatures', payload: successfulFeatures })
				yield put({ type: 'updateFeatureTotalCount', payload: successfulFeatures.length })
				yield put({ type: 'sortFeatures' })
				callback(true)
			} else {
				callback(null)
			}
		},
		*exportFeatures({ callback = noop, payload }, { call, select }) {
			const featuresList = yield select((model) => model.features.featuresList)
			let selectedFeatures = []

			if (payload.featureIds != null && payload.featureIds.length > 0) {
				selectedFeatures = payload.featureIds
			} else {
				selectedFeatures = yield select((model) => model.features.selectedFeatures)
			}

			// if all features are selected, we can pass an empty array
			// to export all features
			if (selectedFeatures.length === featuresList.length) {
				selectedFeatures = []
			}

			const response = yield call(exportFeatures, selectedFeatures, payload.fileType)

			if (response.success && response.data.uuid) {
				callback(response.data.uuid)
			} else {
				console.error('ERROR: unable to export data', response)
				callback(null)
			}
		},
		*updateBulkFeatureStyles({ payload: properties, callback = noop }, { call, select, put }) {
			const { selectedFeatures } = yield select((model) => model.features)

			let updateRes = yield call(updateBulkFeatureStyles, selectedFeatures, properties)

			if (updateRes.success) {
				if (properties.color && properties.icon) {
					const payload = {
						action: 'add',
						recentStyle: {
							color: properties.color,
							icon: properties.icon,
						},
					}
					yield put({ type: 'setRecentWaypointStyles', payload })
				}
				callback(true)
			} else {
				console.error('ERROR: Unable to update features', updateRes)
				callback(false)
			}
		},
		*getFeature({ callback, payload: featureId }, { call, put }) {
			const featureRes = yield call(getFeatureById, featureId)
			if (featureRes.success) {
				callback(featureRes.data)
			} else {
				console.error('ERROR: Failed to get feature', featureRes)
				callback(null, featureRes.data.response)
			}
		},
		// May be able to remove this after UDAPI Sharing is in place
		*getShareToken({ callback = noop, payload: featureId }, { call, put }) {
			const shareRes = yield call(getShareToken, featureId)

			if (shareRes.data.success) {
				const token = shareRes.data.result

				const shortShareRes = yield call(getShortShareLink, token)

				if (shortShareRes.success) {
					const shortShareLink = shortShareRes.data.shortLink
					callback(shortShareLink)
				} else {
					console.error('ERROR: failed to get short link', shortShareRes)
					callback()
				}
			} else {
				console.error('ERROR: failed to get share token', shareRes)
				callback()
			}
		},
		*getFeaturesList({ callback = noop }, { select }) {
			const featuresList = yield select((model) => model.features.featuresList)
			callback(featuresList)
		},
		*getSelectedFeature({ callback = noop}, { select }) {
			const { selectedFeature } = yield select((model) => model.features)
			callback(selectedFeature)
		},
		*revertMultipleFeaturesToPreviousState({ callback = noop }, { put, select }) {
			const { previousFeaturesState } = yield select((model) => model.features)

			yield put({
				type: 'updateMultipleFeatures',
				payload: previousFeaturesState,
			})

			yield put({
				type: 'map/updateMultipleFeatureGraphics',
				payload: {
					features: previousFeaturesState,
					layerId: MAP_LAYER_IDS.content,
				},
			})
			callback(true)
		},
		*revertFeatureToPreviousState({ callback = noop }, { put, select }) {
			const { previousFeatureState } = yield select((model) => model.features)

			if (previousFeatureState) {
				// to account for newFeature
				yield put({ type: 'updateFeature', payload: previousFeatureState })
				yield put({
					type: 'map/updateFeatureGraphic',
					payload: {
						feature: previousFeatureState,
						layerId: MAP_LAYER_IDS.content,
					},
				})
				callback(previousFeatureState)
			}
		},
		*setFeaturesVisibility({ callback = noop, payload }, { select, put }) {
			const { collectionsList } = yield select((model) => model.collections)
			const { featuresList, preferences } = yield select((model) => model.features)
			const { collectionId, featureId, type, visibility } = payload
			let visibilityPayload = []
			const layerId = MAP_LAYER_IDS.content

			if (type === 'all') {
				yield put({
					type: 'map/setAllFeatureGraphicsVisibility',
					payload: { layerId, visibility },
				})
				visibilityPayload = [{ type, visibility }]
			} else {
				let featureIndex = null
				payload = {
					featureIds: [],
					visibility
				}
				if (type === 'collection') {
					const collectionIndex = collectionsList.findIndex((cl) => cl.uuid === collectionId)
					if (collectionIndex > -1) {
						const selectedCollection = collectionsList[collectionIndex]
						for (let fidi = 0; fidi < selectedCollection.featureIds.length; fidi++) {
							featureIndex = featuresList.findIndex(fl => fl.uuid === selectedCollection.featureIds[fidi])
							if (featureIndex > -1) {
								payload.featureIds.push(featuresList[featureIndex].id)
							}
						}
					}
				} else if (type === 'feature') {
					featureIndex = featuresList.findIndex(fl => fl.uuid === featureId)
					if (featureIndex > -1) {
						payload.featureIds.push(featuresList[featureIndex].id)
					}
				}

				yield put({
					type: 'map/setFeatureGraphicsVisibilityById',
					payload: { layerId, ...payload },
				})
				visibilityPayload = setVisibleFeaturePayloads({ featuresList, payload, preferences })
			}
			yield put({ type: 'setVisibleFeaturesEffect', payload: visibilityPayload })
			callback()
		},
		*toggleAllCheckboxes({ callback = noop, payload }, { put, select }) {
			if (payload) {
				yield put({
					type: 'addToSelectedFeatures',
					payload: {
						type: 'all',
					},
				})
			} else {
				yield put({
					type: 'resetAllSelectedFeatures',
				})
			}
			callback()
		},
		*resetSelectedFeatures({ callback = noop, payload = '' }, { put, select }) {
			let dispatchParams = null
			if (payload && payload === 'single') {
				dispatchParams = { type: 'resetSelectedFeature' }
			} else {
				dispatchParams = { type: 'resetAllSelectedFeatures' }
			}
			yield put({ ...dispatchParams })
			callback(true)
		},
		*getNewPhotoIdEffect({ callback = noop, payload }, { call }) {
			const photoIdRes = yield call(getNewPhotoId, payload)

			if (photoIdRes.success) {
				callback(photoIdRes.data.uuid)
			} else {
				console.error('ERROR: Unable to create new photoId.', photoIdRes)
				callback(null)
			}
		},
		*addFeatureToCollectionsEffect({ payload, callback = noop }, { call, select }) {
			const feature = yield select((model) => model.features.selectedFeature)
			const collectionIds = payload
			const response = yield call(addCollectionsToFeature, feature.uuid, collectionIds)

			if (response.success) {
				callback(response)
			} else {
				console.error('ERROR: Unable to add feature to hunts', response)
				callback(null)
			}
		},
		*removeFeaturesFromCollectionEffect({ payload, callback = noop }, { call, select }) {
			// This is currently not being used
			// We use the same effect from collections instead - WD
			const feature = yield select((model) => model.features.selectedFeature)

			if (!feature) {
				callback(null)
			}

			const deleteRes = yield call(removeCollectionsFromFeature, feature.uuid, [payload.collectionId])

			if (deleteRes.success) {
				callback(deleteRes)
			} else {
				console.error('ERROR: Unable to update hunts', deleteRes)
				callback(null)
			}
		},
		*deleteSelectedFeatures({ callback = noop, payload }, { call, put, select }) {
			const featuresList = yield select((model) => model.features.featuresList)
			let deletedFeatureIds = []
			let deleteResponse = null
			let nonDeletedFeatureIds = []
			/* 
       At this moment, notes and photos are automatically deleted.
       This may change in the near future and that is when we can
       implement a prompt for the user to decide if they want to
       delete the notes and/or photos.
       - June 10th, 2022
     */
			const params = {
				queryParams: {
					deleteNotes: true,
					deletePhotos: true,
				},
			}
			if (featuresList.length === payload.featureIds.length) {
				payload.featureIds = featuresList.map((fl) => fl.uuid)
			}

			const featureIdsChunk = chunk(payload.featureIds, 500)
			for (let featureIdChunk of featureIdsChunk) {
				deleteResponse = yield call(deleteFeatures, featureIdChunk, params)
				if (deleteResponse.success) {
					deletedFeatureIds = [...deletedFeatureIds, ...deleteResponse.data.successful.map(s => s.uuid)]
					nonDeletedFeatureIds = [...nonDeletedFeatureIds, ...deleteResponse.data.failed.map(f => f.uuid)]
				} else {
					nonDeletedFeatureIds = [...nonDeletedFeatureIds, ...featureIdChunk]
				}
			}

			if (deletedFeatureIds.length) {
				yield put({
					type: 'map/removeMultipleFeatureGraphicsById',
					payload: {
						featureIds: deletedFeatureIds,
						layerId: MAP_LAYER_IDS.content,
					}
				})
				let collectionIds = []
				let featureIndex = null
				let featuresListCount = 0
				for (let dfidi = 0; dfidi < deletedFeatureIds.length; dfidi++) {
					featureIndex = featuresList.findIndex(fl => fl.uuid === deletedFeatureIds[dfidi])
					if (featureIndex > -1) {
						collectionIds.push(...featuresList[featureIndex].collectionIds)
					}
				}
				if (collectionIds.length) {
					const { collectionsList } = yield select((model) => model.collections)
					let collectionFeatureIds = []
					let collectionIndex = null
					let featureIdIndex = null
					let uniqueCollectionIds = [...new Set(collectionIds)]

					for (let ucidi = 0; ucidi < uniqueCollectionIds.length; ucidi++) {
						collectionIndex = collectionsList.findIndex(cl => cl.uuid === uniqueCollectionIds[ucidi])
						if (collectionIndex > -1) {
							if (collectionsList[collectionIndex].featureIds.length) {
								for (let dfi = 0; dfi < deletedFeatureIds.length; dfi++) {
									featureIdIndex = collectionsList[collectionIndex].featureIds.indexOf(deletedFeatureIds[dfi])
									if (featureIdIndex > -1) {
										collectionFeatureIds.push(deletedFeatureIds[dfi])
									}
								}
								yield put({
									type: 'collections/removeFeaturesFromCollectionsList',
									payload: { collectionId: collectionsList[collectionIndex].uuid, featureIds: collectionFeatureIds },
								})
							}
						}
					}
				}

				for (let fli = 0; fli < featuresList.length; fli++) {
					if (!deletedFeatureIds.includes(featuresList[fli].uuid)) {
						featuresListCount += 1
						break
					}
				}
				if (!featuresListCount) {
					yield put({ type: 'setVisibleFeaturesEffect', payload: [{ type: 'all', visibility: true }] })
				}
				yield put({
					type: 'deleteFeaturesFromUserData',
					payload: deletedFeatureIds,
				})
				callback(true)
			} else {
				console.error('ERROR: Unable to delete selected features', nonDeletedFeatureIds)
				callback(null)
			}
		},
		*addSelectedFeaturesToCollections({ callback = noop, payload }, { call }) {
			const { featureIds, collectionIds } = payload
			const response = yield call(addFeaturesToCollections, featureIds, collectionIds)

			if (response.data.successful.features?.length > 0) {
				/*
          #TODO: The data object contains a "successful" and "failed"
          object which contains the collections/features that succeeded
          or failed. This can be used for robust error handling.
          --  - July 07, 2021
        */
				callback(response)
			} else {
				console.error('ERROR: Unable to add selected features to hunt', response)
				callback(null)
			}
		},
		*deleteFeatureEffect({ callback = noop, payload: featureUuid }, { call, select, put }) {
			let featuresList = yield select((model) => model.features.featuresList)
			let feature = featuresList.find((fl) => fl.uuid == featureUuid)
			if (!feature) {
				callback()
			}
			/* 
        At this moment, notes and photos are automatically deleted.
        This may change in the near future and that is when we can
        implement a prompt for the user to decide if they want to
        delete the notes and/or photos.
        - June 10th, 2022
      */
			const params = {
				queryParams: {
					deleteNotes: true,
					deletePhotos: true,
				},
			}
			let response = yield call(deleteFeature, feature, params)
			if (response.success) {
				yield put({ type: 'updateFeatureTotalCount', payload: -1 })
				yield put({
					type: 'map/removeGraphicByFeatureId',
					payload: {
						featureId: feature.uuid,
						layerId: MAP_LAYER_IDS.content,
					},
				})
				yield put({
					type: 'deleteFeatureFromUserData',
					payload: feature.uuid,
				})
				if (feature.collectionIds.length) {
					for (let collectionId of feature.collectionIds) {
						yield put({
							type: 'collections/removeFeaturesFromCollectionsList',
							payload: { collectionId, featureIds: [feature.uuid] },
						})
					}
				}
				const featuresListCount = featuresList.length - 1
				if (!featuresListCount) {
					yield put({ type: 'setVisibleFeaturesEffect', payload: [{ type: 'all', visibility: true }] })
				}
				callback(true)
			} else {
				console.error('ERROR: Unable to delete feature', response)
				callback(false)
			}
		},
		*deleteSelectedFeatureEffect({ callback = noop }, { call, select, put }) {
			const feature = yield select((model) => model.features.selectedFeature)
			if (!feature.uuid) {
				callback()
			} else {
				yield put({
					type: 'deleteFeatureEffect',
					callback,
					payload: feature.uuid,
				})
			}
		},
		*deletePhotoEffect({ payload: photoId, callback = noop  }, { call, select, put }) {
			const feature = yield select((model) => model.features.selectedFeature)
			if (!feature.uuid) {
				/*
          #TODO: better error handling
          -- KD - April 27, 2020
        */
				return
			}

			let response = yield call(deletePhoto, photoId)
			if (response.success) {
				const photoIndex = feature.photos.findIndex((photo) => photo.uuid === photoId)
				if (photoIndex !== -1) {
					feature.photos.splice(photoIndex, 1)
				}

				const photoIdIndex = feature.photoIds.findIndex((itemPhotoId) => itemPhotoId === photoId)
				if (photoIdIndex !== -1) {
					feature.photoIds.splice(photoIdIndex, 1)
				}

				yield put({ type: 'setSelectedFeature', payload: { ...feature } })
				// update featureList as well
				callback(true)
			} else {
				console.error('ERROR: Unable to delete photo', response)
				callback(false)
			}
		},
		*updateFeatureEffect({ callback = noop }, { call, select, put }) {
			const { selectedFeature } = yield select((model) => model.features)
			if (!selectedFeature.uuid) {
				callback()
			}

			if (selectedFeature.properties.ghType === FEATURE_TYPES.Point) {
				const payload = {
					action: 'add',
					recentStyle: {
						color: selectedFeature.properties.color,
						icon: selectedFeature.properties.icon,
					},
				}
				yield put({ type: 'setRecentWaypointStyles', payload })
			}

			let updateRes = yield call(updateFeature, selectedFeature)
			if (updateRes.success) {
				callback(updateRes.data)
			} else {
				console.error('ERROR: Unable to update feature', updateRes)
				callback(false)
			}
		},
		*saveFeatureEffect({ callback = noop }, { call, put, select }) {
			const feature = yield select((model) => model.features.newFeature)
			let featureRes = yield call(saveFeature, feature)

			if (featureRes.success) {
				const { collectionsList, preferences } = yield select((model) => model.collections)
				const collectionIndex = collectionsList.findIndex(cl => cl.uuid === preferences.pinned)
				if (collectionIndex > -1) {
					yield call(addFeatureToCollections, [featureRes.data.uuid], preferences.pinned)
					yield put({
						type: 'collections/addFeatureToCollectionsList',
						payload: {
							collectionIds: [preferences.pinned],
							featureId: featureRes.data.uuid,
						},
					})
				}
				callback(featureRes.data.uuid)
			} else {
				callback(null, featureRes.data.response)
				console.error('ERROR: Unable to save feature', featureRes)
			}
		},
		*saveFeatureFavorites({ payload }, { put, select }) {
			const { preferences: { favorites } } = yield select((model) => model.features)
			let dispatchParams = null
			let action = null
			switch (payload.type) {
				case 'icons':
					if (favorites.icons.includes(payload.icon)) {
						action = 'remove'
					} else {
						action = 'add'
					}
					dispatchParams = { type: 'setFavoriteIcons', payload: { action, icon: payload.icon } }
					break
			}
			yield put(dispatchParams)
		},
		*removeFeatureFromUserDataEffect({ callback = noop, payload: featureId }, { call, put, select }) {
			let featuresList = yield select((model) => model.features.featuresList)
			yield put({ type: 'updateFeatureTotalCount', payload: -1 })
			yield put({
				type: 'map/removeGraphicByFeatureId',
				payload: {
					featureId: featureId,
					layerId: MAP_LAYER_IDS.content,
				},
			})
			yield put({
				type: 'deleteFeatureFromUserData',
				payload: featureId,
			})
			const feature = featuresList.find((fl) => fl.uuid === featureId)
			if (feature && feature.collectionIds.length) {
				yield put({
					type: 'collections/removeFeatureFromCollections',
					payload: {
						collectionIds: feature.collectionIds,
						featureId,
					},
				})
			}
			if (featuresList.length - 1 === 0) {
				yield put({ type: 'setVisibleFeaturesEffect', payload: [{ type: 'all', visibility: true }] })
			}
			callback(true)
		},
		*completeEditFeature(_, { select, put }) {
			const { sketchViewModel } = yield select((model) => model.map)
			sketchViewModel.updateOnGraphicClick = false
			yield sketchViewModel.complete()
			yield put({ type: 'map/setIsUpdatingLocation', payload: false })
			yield put({ type: 'map/clearGhostLayer' })
		},
		*cancelEditFeature(_, { select, put }) {
			const { sketchViewModel } = yield select((model) => model.map)
			sketchViewModel.updateOnGraphicClick = false
			yield sketchViewModel.cancel()
			yield put({ type: 'map/setIsUpdatingLocation', payload: false })
			yield put({ type: 'map/clearGhostLayer' })
		},
		*enableEditFeature({ payload, callback = noop }, { select, put }) {
			const { mapRef, sketchViewModel } = yield select((model) => model.map)
			const feature = yield select((model) => model.features.selectedFeature)

			const layer = mapRef.findLayerById(MAP_LAYER_IDS.content)

			const foundGraphic = layer.graphics.find((graphic) => {
				return graphic.attributes.id === feature.uuid
			})

			sketchViewModel.updateOnGraphicClick = true
			sketchViewModel.update([foundGraphic], { tool: 'move' })

			yield put({
				type: 'map/renderGhostFeatureGraphic',
				payload: { feature },
			})
			yield put({ type: 'map/setIsUpdatingLocation', payload: true })
		},
		/*
      #NOTE: This is a debug effect.
      -- TJC - August 30, 2021
    */
		// *discoverDuplicateIds({ payload, callback = noop}, { select, put }) {
		//   const { featuresList } = yield select((model) => model.features);
		//   let featureIds = [];
		//   let duplicateFeatures = [];

		//   featuresList.forEach((feature, i) => {
		//     if (featureIds.includes(feature.uuid)) {
		//       duplicateFeatures.push({ uuid: feature.uuid, name: feature.title, index: i } );
		//     } else {
		//       featureIds.push(feature.uuid);
		//     }
		//   });
		// },
		*loadPhotosDataEffect({ callback = noop }, { call, put, select }) {
			const selectedFeature = yield select((model) => model.features.selectedFeature)

			if (selectedFeature) {
				const photos = yield call(() => {
					let photos = []

					const promises = selectedFeature.photoIds.map((id) => {
						return getPhoto(id)
					})

					return Promise.all(promises)
						.then((results) => {
							results.forEach((item) => {
								if (item.success) {
									photos.push(item.data)
								}
							})

							return photos
						})
						.catch((err) => {
							console.error(err)
							return []
						})
				})

				selectedFeature.photos = photos
				yield put({
					type: 'setSelectedFeature',
					payload: { ...selectedFeature },
				})

				callback()
				// update featuresList as well
			}
		},
		*clearRecentWaypointStyles(_, { put }) {
			yield put({ type: 'setRecentWaypointStyles', payload: { action: 'clear' } })
		},
		*sortFeatures({ payload }, { put, select }) {
			const { featuresList, sort } = yield select((model) => model.features)
			const key = payload || sort
			let order = 'asc'
			let sortedFeaturesList = [...featuresList]
			if (['createdAt', 'updatedAt', 'ghType'].includes(key)) {
				if (key !== 'ghType') order = 'desc'
				sortedFeaturesList = orderBy(sortedFeaturesList, (fl) => fl.properties[key], [order])
			} else {
				sortedFeaturesList = orderBy(sortedFeaturesList, [key], [order])
			}
			if (key !== sort) {
				yield put({ type: 'setSort', payload: key })
			}
			yield put({ type: 'setFeaturesList', payload: sortedFeaturesList })
			yield put({ type: 'setIsSortingItems', payload: false })
		},
		*setVisibleFeaturesEffect({ callback = noop, payload }, { put, select }) {
			const { preferences } = yield select((model) => model.features)
			const updatedAt = Math.floor(Date.now() / 1000)
			let data = { jobs: [] }
			let newVisibleFeatures = []

			for (let p of payload) {
				switch (p.type) {
					case 'all':
						preferences.visible = {
							all: p.visibility,
							collections: [],
							features: [],
						}
						data.jobs.push(
							{ action: 'change', path: 'features/visible/all', values: [preferences.visible.all] },
							// { action: 'clear', path: 'features/visible/collections' },
							{ action: 'clear', path: 'features/visible/features' },
							{ action: 'change', path: 'features/visible/updatedAt', values: [updatedAt] }
						)
						break
					case 'feature':
						if (p.visibility) {
							newVisibleFeatures = [...preferences.visible.features, ...p.features]
						} else {
							for (let feature of preferences.visible.features) {
								if (!p.features.includes(feature)) {
									newVisibleFeatures.push(feature)
								}
							}
						}
						data.jobs.push({ action: p.visibility ? 'add' : 'remove', path: 'features/visible/features', values: [...p.features] })

						preferences.visible.features = newVisibleFeatures
						if (preferences.visible.all) {
							preferences.visible.all = false
							data.jobs.push({ action: 'change', path: 'features/visible/all', values: [preferences.visible.all] })
						}
						data.jobs.push({ action: 'change', path: 'features/visible/updatedAt', values: [updatedAt] })
						break
				}
			}
			
			if (data.jobs.length) {
				saveVisibleFeatures(data)
				yield put({ type: 'setVisibleFeatures', payload: { visible: { ...preferences.visible, updatedAt } } })
			}
			callback()
		}
	},
	reducers: {
		updateFeatureTotalCount(state, { payload }) {
			return {
				...state,
				pagination: {
					...state.pagination,
					total: state.pagination.total + payload,
				},
			}
		},
		clearFeatures(state, action) {
			return {
				...state,
				featuresList: [],
			}
		},
		resetFiltersAndSort(state, action) {
			return {
				...state,
				sort: 'updated',
				filters: {
					...state.filters,
					states: Object.keys(STATES_DATA).map((name) => ({
						name,
						checked: true,
					})),
					types: [...Object.keys(FEATURE_FILTERS)],
				},
			}
		},
		appendFeatures(state, { payload: features }) {
			const featuresList = [...state.featuresList, ...features]
			return {
				...state,
				featuresList,
				hasLargeFeatureDataSet:featuresList.length >= LARGE_DATA_SET_COUNT.Features
			}
		},
		prependFeatures(state, { payload: features }) {
			const featuresList = [...features, ...state.featuresList]
			return {
				...state,
				featuresList,
				hasLargeFeatureDataSet:featuresList.length >= LARGE_DATA_SET_COUNT.Features
			}
		},
		setSort(state, { payload: sort }) {
			return {
				...state,
				sort,
			}
		},
		setFeatureTypeFilter(state, { payload: filter }) {
			return {
				...state,
				filters: {
					...state.filters,
					types: filter,
				},
			}
		},
		setOffset(state, { payload: offset }) {
			return {
				...state,
				pagination: {
					...state.pagination,
					offset: offset,
				},
			}
		},
		setFeatureTotalCount(state, { payload: count }) {
			return {
				...state,
				pagination: {
					...state.pagination,
					total: count,
				},
			}
		},
		setFeaturesLoading(state, { payload: loading }) {
			return {
				...state,
				featuresLoading: loading,
			}
		},
		setMoreFeaturesLoading(state, { payload: loading }) {
			return {
				...state,
				moreFeaturesLoading: loading,
			}
		},
		setFeaturesList(state, { payload: featuresList }) {
			return {
				...state,
				featuresList,
			}
		},
		/*
      #TODO: This is also in the map model
      -- WD - May 21, 2020
    */
		selectFeature(state, { payload: feature }) {
			return {
				...state,
				selectedFeature: feature,
			}
		},
		setPreviousFeatureState(state, { payload: feature }) {
			return {
				...state,
				previousFeatureState: cloneDeep(feature),
			}
		},
		applyStatesFilter(state, { payload }) {
			return {
				...state,
				filters: {
					...state.filters,
					states: [...payload],
				},
			}
		},
		removePhoto(state, { payload }) {
			const { featuresList } = state

			const featureIndex = featuresList.findIndex(fl => fl.uuid === payload.featureId)
			if (featureIndex > -1) {
				const feature = featuresList[featureIndex]
				const photoIndex = feature.photoIds.findIndex(pid => pid === payload.photoId)
				if (photoIndex > -1) {
					feature.photoIds.splice(photoIndex, 1)
					featuresList[featureIndex] = feature
				}
			}

			return {
				...state,
				featuresList,
			}
		},
		addFeatureToCollections(state, { payload }) {
			const { featuresList } = state

			const featureIndex = featuresList.findIndex(fl => fl.uuid === payload.featureId)
			if (featureIndex > -1) {
				const feature = featuresList[featureIndex]
				feature.collectionIds.push(...payload.collectionIds)
				featuresList[featureIndex] = feature
			}
			return {
				...state,
				featuresList,
			}
		},
		removeCollectionFromFeaturesList(state, { payload }) {
			// This function removes a collection from a feature and sets the updated featureList
			const { featuresList } = state
			const featureIndex = featuresList.findIndex(fl => fl.uuid === payload.featureId)
			if (featureIndex > -1) {
				const feature = featuresList[featureIndex]
				const collectionIdIndex = feature.collectionIds.indexOf(payload.collectionId)
				if (collectionIdIndex > -1) {
					feature.collectionIds.splice(collectionIdIndex, 1)
					featuresList[featureIndex] = feature
				}
			}
			return {
				...state,
				featuresList,
			}
		},
		addNewFeatureToUserData(state, { payload: feature }) {
			const featuresList = [feature, ...state.featuresList]
			return {
				...state,
				featuresList,
				hasLargeFeatureDataSet: state.featuresList.length >= LARGE_DATA_SET_COUNT.Features,
			}
		},
		deleteFeatureFromUserData(state, { payload: featureId }) {
			const { featuresList } = state
			const featureIndex = featuresList.findIndex(fl => fl.uuid === featureId)
			if (featureIndex > -1) {
				featuresList.splice(featureIndex, 1)
			}
			return {
				...state,
				featuresList,
				hasLargeFeatureDataSet: state.featuresList.length >= LARGE_DATA_SET_COUNT.Features,
			}
		},
		deleteFeaturesFromUserData(state, { payload: featureIds }) {
			const newFeaturesList = []
			for (let fli = 0; fli < state.featuresList.length; fli++) {
				if (!featureIds.includes(state.featuresList[fli].uuid)) {
					newFeaturesList.push(state.featuresList[fli])
				}
			}
			return {
				...state,
				featuresList: newFeaturesList,
				hasLargeFeatureDataSet: state.featuresList.length >= LARGE_DATA_SET_COUNT.Features,
			}
		},
		updateFeature(state, { payload: feature }) {
			const { featuresList } = state
			const featureIndex = featuresList.findIndex(fl => fl.uuid == feature.uuid)
			if (featureIndex > -1) {
				featuresList[featureIndex] = feature
			}
			return {
				...state,
				featuresList
			}
		},
		updateMultipleFeatures(state, { payload: features }) {
			const { featuresList } = state
			let feature = null
			let featureIndex = null
			for (let fi = 0; fi < features.length; fi++) {
				feature = features[fi]
				featureIndex = featuresList.findIndex(fl => fl.uuid == feature.uuid)
				if (featureIndex > -1) {
					featuresList[featureIndex] = feature
				}
			}
			return {
				...state,
				featuresList
			}
		},
		addPhotoToSelectedFeature(state, { payload }) {
			return {
				...state,
				selectedFeature: {
					...state.selectedFeature,
					photos: state.selectedFeature.photos ? [...state.selectedFeature.photos, payload] : [payload],
					photoIds: [...state.selectedFeature.photoIds, payload.uuid],
				},
			}
		},
		addToSelectedFeatures(state, { payload: { featureIds, type } }) {
			const featuresListIds = state.featuresList.map((fl) => fl.uuid)
			if (type === 'all') {
				state.selectedFeatures = [...featuresListIds]
				state.previousFeaturesState = [...state.featuresList]
				for (let fli = 0; fli < state.featuresList.length; fli++) {
					state.featuresList[fli].isSelected = true
				}
			} else {
				for (let fidi = 0; fidi < featureIds.length; fidi++) {
					const featureIndex = featuresListIds.indexOf(featureIds[fidi])
					if (featureIndex > -1) {
						state.previousFeaturesState.push(state.featuresList[featureIndex])
						state.featuresList[featureIndex].isSelected = true
						state.selectedFeatures.push(state.featuresList[featureIndex].uuid)
					}
				}
			}
			state.selectedFeaturesCount = state.selectedFeatures.length
			return {
				...state,
			}
		},
		removeFromSelectedFeatures(state, { payload: { featureIds } }) {
			const featuresListIds = state.featuresList.map((fl) => fl.uuid)
			for (let fidi = 0; fidi < featureIds.length; fidi++) {
				const featureIndex = featuresListIds.indexOf(featureIds[fidi])
				if (featureIndex > -1) {
					const previousFeaturesStateIndex = state.previousFeaturesState.findIndex((pfs) => pfs.uuid === featureIds[fidi])
					if (previousFeaturesStateIndex > -1) {
						state.previousFeaturesState.splice(previousFeaturesStateIndex, 1)
					}
					const selectedFeatureIndex = state.selectedFeatures.indexOf(featureIds[fidi])
					if (selectedFeatureIndex > -1) {
						state.selectedFeatures.splice(selectedFeatureIndex, 1)
					}
					state.featuresList[featureIndex].isSelected = false
				}
			}
			state.selectedFeaturesCount = state.selectedFeatures.length
			return {
				...state,
			}
		},
		addSelectedFeaturesFromMap(state, { payload: selectedFeatureIds }) {
			const updatedFeatureList = uniq([...state.mapSelectList, ...selectedFeatureIds])
			const previousFeaturesState = []
			for (let fli = 0; fli < state.featuresList.length; fli++) {
				if (updatedFeatureList.indexOf(state.featuresList[fli].uuid) !== -1) {
					previousFeaturesState.push(state.featuresList[fli])
				}
			}

			return {
				...state,
				mapSelectList: updatedFeatureList,
				selectedFeatures: updatedFeatureList,
				previousFeaturesState,
			}
		},
		resetAllSelectedFeatures(state) {
			const featureIds = state.featuresList.map((nfl) => nfl.uuid)
			for (let sfi = 0; sfi < state.selectedFeatures.length; sfi++) {
				const featureIndex = featureIds.indexOf(state.selectedFeatures[sfi])
				if (featureIndex > -1) {
					state.featuresList[featureIndex].isSelected = false
				}
			}
			return {
				...state,
				previousFeaturesState: [],
				selectedFeatures: [],
				selectedFeaturesCount: 0,
			}
		},
		resetMapSelectList(state) {
			return {
				...state,
				mapSelectList: [],
			}
		},
		setSelectedFeatureLoading(state, { payload: loading }) {
			return {
				...state,
				selectedFeatureLoading: loading,
			}
		},
		updateSelectedFeature(state, { payload: feature }) {
			return {
				...state,
				// isFeatureDirty: false,
				selectedFeature: {
					...state.selectedFeature,
					...feature,
				},
			}
		},
		setSelectedFeature(state, { payload: feature }) {
			return {
				...state,
				selectedFeature: feature,
			}
		},
		initNewFeature(state, { payload: feature }) {
			return {
				...state,
				// isFeatureDirty: false,
				newFeature: feature,
			}
		},
		updateNewFeature(state, { payload: feature }) {
			return {
				...state,
				newFeature: feature,
			}
		},
		cancelNewFeature(state) {
			return {
				...state,
				// isFeatureDirty: false,
				newFeature: null,
			}
		},
		clearSelectedFeature(state) {
			return {
				...state,
				// isFeatureDirty: false,
				selectedFeature: null,
			}
		},
		resetSelectedFeature(state, { payload: feature }) {
			return {
				...state,
				// isFeatureDirty: false,
				selectedFeature: cloneDeep(feature),
			}
		},
		// setFeatureDirty(state, { payload }) {
		//   return {
		//     ...state,
		//     isFeatureDirty: payload,
		//   };
		// },
		setIsEditingFeature(state, { payload: status }) {
			return {
				...state,
				isEditingFeature: status,
			}
		},
		setHasLargeDataSet(state, { payload: status }) {
			return {
				...state,
				hasLargeFeatureDataSet: status,
			}
		},
		setIsDeletingItems(state, { payload: status }) {
			return {
				...state,
				isDeletingItems: status,
			}
		},
		setIsSortingItems(state, { payload: status }) {
			return {
				...state,
				isSortingItems: status,
			}
		},
		setIsShowingItems(state, { payload: status }) {
			return {
				...state,
				isShowingItems: status,
			}
		},
		setIsHidingItems(state, { payload: status }) {
			return {
				...state,
				isHidingItems: status,
			}
		},
		setIsSettingVisibility(state, { payload: status }) {
			return {
				...state,
				isSettingVisibility: status,
			}
		},
		setIsSaving(state, { payload: status }) {
			return {
				...state,
				isSaving: status,
			}
		},
		setIsCreatingItems(state, { payload: status }) {
			return {
				...state,
				isCreatingItems: status,
			}
		},
		setIsSelectingItems(state, { payload: status }) {
			return {
				...state,
				isSelectingItems: status,
			}
		},
		setIsDeselectingItems(state, { payload: status }) {
			return {
				...state,
				isDeselectingItems: status,
			}
		},
		setIsCanceling(state, { payload: status }) {
			return {
				...state,
				isCanceling: status,
			}
		},
		toggleEditingFeature(state) {
			return {
				...state,
				isEditingFeature: !state.isEditingFeature,
			}
		},
		setIsUploadingPhoto(state, { payload: status }) {
			return {
				...state,
				isUploadingPhoto: status,
			}
		},
		setFeatureError(state, { payload }) {
			const { featureErrorId, hasFeatureErrored } = payload
			return {
				...state,
				featureErrorId: featureErrorId,
				hasFeatureErrored: hasFeatureErrored,
			}
		},
		setVisibleFeatures(state, { payload: { visible } }) {
			const { preferences } = state
			if (preferences.deprecated) {
				delete preferences.deprecated
			}
			return {
				...state,
				preferences: {
					...preferences,
					visible
				}
			}
		},
		setRecentWaypointStyles(state, { payload }) {
			const { styles } = state.preferences.recents
			const data = { jobs: [] }

			if (payload.action === 'add') {
				const isDuplicateStyle = styles.points.find((p) => isEqual(p, payload.recentStyle))
				if (!isDuplicateStyle) {
					styles.points = [payload.recentStyle, ...styles.points]
					data.jobs.push({ action: payload.action, path: 'recents/features/styles/points', values: [payload.recentStyle] })
				}
			} else if (payload.action === 'clear') {
				styles.points = []
				data.jobs.push({ action: payload.action, path: 'recents/features/styles/points' })
			}

			if (data.jobs.length) {
				saveRecentStyles(data)
			}
			return {
				...state,
			}
		},
		setFavoriteIcons(state, { payload }) {
			const { favorites } = state.preferences
			const data = { jobs: [] }

			if (payload.action === 'add') {
				favorites.icons.unshift(payload.icon)
				data.jobs.push({ action: 'add', path: 'favorites/icons', values: [payload.icon] })
			} else if (payload.action === 'remove') {
				const iconIndex = favorites.icons.indexOf(payload.icon)
				if (iconIndex > -1) {
					favorites.icons.splice(iconIndex, 1)
					data.jobs.push({ action: 'remove', path: 'favorites/icons', values: [payload.icon] })
				}
			}

			if (data.jobs.length) {
				saveFavoriteIcons(data)
			}
			return {
				...state,
			}
		},
		setAllPreferences(state, { payload }) {
			return {
				...state,
				preferences: {
					...payload,
				},
			}
		},
		setNewVisibleFeatures(state, { payload }) {
			const { newVisibleFeatures } = state
			return {
				...state,
				newVisibleFeatures: [...newVisibleFeatures, ...payload]
			}
		},
	},
}
